var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"moveR"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"zn-alpha-template"},[(_vm.activeComponent)?_c(_vm.activeComponent,{ref:"compt",tag:"component",attrs:{"componentName":_vm.activeComponent,"item":_vm.item},on:{"closeTpl":_vm.closeTpl}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }